<template>
  <button
    id="mobile-search-icon"
    :aria-expanded="isMobileSearchBarExpanded"
    aria-controls="navSearchContainer"
    @click="focusMobileSearchBar"
  >
    <pdl-icon name="search" :label="$t('text.search')" />
  </button>
</template>
<script>
import {PdlIcon} from '@pedal/pdl-icon';
export default {
  name: 'NavMobileSearchIcon',
  components: {
    PdlIcon,
  },
  inject: ['focusMobileSearchBar', 'isMobileSearchBarExpanded'],
};
</script>
